Ext.define('SA.view.sidebar.location.CustomLocationsList', {
    alias: 'widget.custom-locations-list',
    extend: 'SA.view.sidebar.SidebarList',

    items: [
        {
            handler: 'onViewClick',
            icon: 'sa-icon-custom-location',
            text: 'View your custom locations'
        }, {
            handler: 'onRadiusClick',
            icon: 'sa-icon-radius-location',
            text: 'Create new radius location'
        }, {
            handler: 'onCombinationClick',
            icon: 'sa-icon-combination-location',
            text: 'Create new combination location'
        }
    ],

    onCombinationClick() {
        Ext.widget({
            xtype: 'create-combination-location',

            callback: combo => {
                this.up('[useLocation]').useLocation(combo);
            },

            listeners: {
                destroy: () => {
                    this.setSelected(null);
                }
            }
        });
    },

    onRadiusClick() {
        Ext.widget({
            xtype: 'create-radius-location',
            autoShow: true,

            callback: radiusLocation => {
                this.up('[useLocation]').useLocation(radiusLocation);
            },

            listeners: {
                destroy: () => {
                    this.setSelected(null);
                }
            }
        });
    },

    onViewClick(item) {
        var me = this,
            list = this.customLocationsList,
            el = this.getItemEl(item),
            Locations = SA.data.LocationsCache,
            country = SA.AppController.getCurrentCountryCode(),
            countryUnits = SA.data.GeographicUnits.findIds({country, includeCountry: true});

        if (list && list.wasRecentlyVisible()) {
            this.setSelected(null);

            return;
        }

        if (!list) {
            list = this.customLocationsList = Ext.widget({
                xtype: 'recent-custom-locations-list',
                pickerOwner: this,
                source: SA.data.CustomLocations,
                title: 'Custom Locations',
                track: true,
                width: this.getWidth(),

                listeners: {
                    scope: this,

                    select(list, location) {
                        this.up('[useLocation]').useLocation(location);
                    }
                }
            });
        }

        list.setFilter(countryFilter);
        list.setSelected(this.selectedLocations);

        list.on('hide', () => {
            this.setSelected(null);
        }, null, {single: true});

        list.getPlugin('sa-arrow').setTarget(el);

        list.showBy(el, 'tl-tr', [7, 9]);

        function countryFilter(location) {
            var series = Locations.normalizeLocation(location).locationSeries;
            var firstLocationOfSeries = Locations.get(series[0], me.refresh, me);

            if (!firstLocationOfSeries) {
                return false;
            }

            return countryUnits.includes(firstLocationOfSeries.geographicUnit);
        }
    },

    setSelectedLocations(locations) {
        var list = this.customLocationsList;

        if (list) {
            list.setSelected(locations);
        }

        this.selectedLocations = locations;
    }
});